import { render, staticRenderFns } from "./CashBackRewardEditor.vue?vue&type=template&id=dc8f210c&scoped=true"
import script from "./CashBackRewardEditor.vue?vue&type=script&lang=ts"
export * from "./CashBackRewardEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8f210c",
  null
  
)

export default component.exports